module.exports = __webpack_public_path__ + "static/media/Select-report.938b9bd1.png";